import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ThanksPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F0F7F4] flex flex-col">
      {/* ヘッダー */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 sm:gap-3 cursor-pointer">
            <img src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/0e64fe7d7ddf660e67742842ccecd709.png" alt="ロゴ" className="h-8 sm:h-10 w-auto" />
            <span className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 hidden sm:block">集客・予約・広告 フル自動化パッケージ</span>
          </Link>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="flex-1 flex items-center justify-center px-4 py-12 sm:py-16 lg:py-20">
        <div className="max-w-xl w-full text-center">
          {/* 成功アイコン */}
          <div className="w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-6 sm:mb-8 bg-[#1A3A52] rounded-full flex items-center justify-center">
            <i className="ri-check-line text-4xl sm:text-5xl text-white"></i>
          </div>

          {/* 見出し */}
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-5">
            お申し込みありがとうございます
          </h1>

          {/* メッセージ */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg mb-6 sm:mb-8">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-5">
              ご入力いただいた内容を確認し、<br />
              <strong className="text-[#1A3A52]">24〜48時間以内</strong>にご連絡いたします。
            </p>
            
            <div className="bg-[#F0F7F4] rounded-xl p-4 sm:p-5">
              <h2 className="text-sm sm:text-base font-bold text-gray-900 mb-3">次のステップ</h2>
              <div className="space-y-2 text-left">
                <div className="flex items-start gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-sm font-bold text-[#1A3A52]">1</span>
                  </div>
                  <p className="text-sm text-gray-700">担当者からメールまたはお電話でご連絡</p>
                </div>
                <div className="flex items-start gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-sm font-bold text-[#1A3A52]">2</span>
                  </div>
                  <p className="text-sm text-gray-700">オンラインで現状ヒアリング（30分程度）</p>
                </div>
                <div className="flex items-start gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-sm font-bold text-[#1A3A52]">3</span>
                  </div>
                  <p className="text-sm text-gray-700">改善ポイントと提案をご説明</p>
                </div>
              </div>
            </div>
          </div>

          {/* 注意事項 */}
          <p className="text-xs sm:text-sm text-gray-500 mb-6 sm:mb-8">
            ※ 迷惑メールフォルダもご確認ください<br />
            ※ 営業目的の電話はいたしません
          </p>

          {/* トップへ戻るボタン */}
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-3.5 bg-[#1A3A52] text-white text-sm sm:text-base rounded-lg font-medium hover:bg-[#2A4A62] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            トップページへ戻る
          </Link>
        </div>
      </main>

      {/* フッター */}
      <footer className="bg-[#1A3A52] py-10 sm:py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-4 sm:mb-6">
            <a 
              href="https://superspoon.net/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white text-sm sm:text-base font-medium mb-1 inline-flex items-center gap-2 hover:text-white/80 transition-colors cursor-pointer"
            >
              <span>運営:Superspoon</span>
              <i className="ri-external-link-line text-base"></i>
            </a>
          </div>
          <div className="text-center mb-3 sm:mb-4">
            <a 
              href="/privacy" 
              className="text-white/80 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer"
            >
              プライバシーポリシー
            </a>
          </div>
          <div className="text-center">
            <p className="text-white/60 text-xs">© 2025 SuperSpoon. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
